/* yūgure V3 · Kaki : comportements des sections custom-k-* (module ES, chargé par custom-globals).
   Tout est gardé : chaque fonction ne fait rien si sa section n'est pas sur la page. */
import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';

const TZ = 'Europe/Paris';
const NBSP = ' ';

/* ---------- Soleil : coucher et crépuscule civil (équation de Wikipédia, précision ~1 min) ---------- */
function sunTimes(y, m, d, lat, lon) {
  const rad = Math.PI / 180;
  const J = Date.UTC(y, m - 1, d, 12) / 86400000 + 2440587.5;
  const n = Math.round(J - 2451545.0 + 0.0008);
  const Js = n - lon / 360;
  const M = (357.5291 + 0.98560028 * Js) % 360;
  const C = 1.9148 * Math.sin(M * rad) + 0.02 * Math.sin(2 * M * rad) + 0.0003 * Math.sin(3 * M * rad);
  const L = (M + C + 180 + 102.9372) % 360;
  const Jt = 2451545.0 + Js + 0.0053 * Math.sin(M * rad) - 0.0069 * Math.sin(2 * L * rad);
  const dec = Math.asin(Math.sin(L * rad) * Math.sin(23.4397 * rad));
  const ha = (alt) => Math.acos((Math.sin(alt * rad) - Math.sin(lat * rad) * Math.sin(dec)) / (Math.cos(lat * rad) * Math.cos(dec))) / rad;
  const toDate = (j) => new Date((j - 2440587.5) * 86400000);
  return { set: toDate(Jt + ha(-0.833) / 360), dusk: toDate(Jt + ha(-6) / 360) };
}
function parts(date, opts) {
  const o = {};
  new Intl.DateTimeFormat('fr-FR', { timeZone: TZ, ...opts }).formatToParts(date).forEach((p) => { o[p.type] = p.value; });
  return o;
}
function hm(date) {
  const p = parts(date, { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
  return { h: +p.hour, m: +p.minute, label: `${+p.hour}${NBSP}h${NBSP}${p.minute}` };
}
function todayParis(offset = 0) {
  const p = parts(new Date(), { year: 'numeric', month: 'numeric', day: 'numeric' });
  const d = new Date(Date.UTC(+p.year, +p.month - 1, +p.day + offset, 12));
  return { y: d.getUTCFullYear(), m: d.getUTCMonth() + 1, d: d.getUTCDate() };
}
function dayLabel(t, long = false) {
  return new Intl.DateTimeFormat('fr-FR', { timeZone: 'UTC', weekday: 'short', day: 'numeric', month: long ? 'long' : 'short' })
    .format(new Date(Date.UTC(t.y, t.m - 1, t.d, 12)));
}
function addWorkdays(t, n) {
  const d = new Date(Date.UTC(t.y, t.m - 1, t.d, 12));
  let c = 0;
  while (c < n) { d.setUTCDate(d.getUTCDate() + 1); const w = d.getUTCDay(); if (w !== 0 && w !== 6) c++; }
  return { y: d.getUTCFullYear(), m: d.getUTCMonth() + 1, d: d.getUTCDate() };
}
const setText = (root, sel, txt) => root.querySelectorAll(sel).forEach((el) => { el.textContent = txt; });

function initSoir(root = document) {
  root.querySelectorAll('[data-k-soir]').forEach((el) => {
    const lat = parseFloat(el.dataset.lat || '48.8566');
    const lon = parseFloat(el.dataset.lon || '2.3522');
    const t = todayParis();
    const s = sunTimes(t.y, t.m, t.d, lat, lon);
    const set = hm(s.set), dusk = hm(s.dusk), now = hm(new Date());
    const H0 = 16, SPAN = 7;
    const pos = (x) => Math.max(0, Math.min(100, ((x.h + x.m / 60) - H0) / SPAN * 100));
    setText(el, '[data-k-date]', dayLabel(t, true));
    setText(el, '[data-k-set]', set.label);
    setText(el, '[data-k-crep-lab]', `${set.label} → ${dusk.label}`);
    const jour = el.querySelector('[data-k-jour]'); if (jour) jour.style.width = pos(set) + '%';
    const crep = el.querySelector('[data-k-crep]'); if (crep) { crep.style.left = pos(set) + '%'; crep.style.width = (pos(dusk) - pos(set)) + '%'; }
    const lab = el.querySelector('[data-k-crep-lab]'); if (lab) lab.style.left = pos(set) + '%';
    const nowEl = el.querySelector('[data-k-now]');
    if (nowEl) {
      const v = now.h + now.m / 60;
      if (v >= H0 && v <= H0 + SPAN) { nowEl.hidden = false; nowEl.style.left = pos(now) + '%'; nowEl.classList.toggle('is-fin', pos(now) > 80); setText(nowEl, '[data-k-now-lab]', `maintenant ${now.label}`); }
      else nowEl.hidden = true;
    }
    el.classList.add('is-ready');
  });
  /* Coucher du soleil de demain (pied de page) */
  root.querySelectorAll('[data-k-demain]').forEach((el) => {
    const t = todayParis(1);
    el.textContent = hm(sunTimes(t.y, t.m, t.d, 48.8566, 2.3522).set).label;
    el.closest('[data-k-demain-wrap]')?.removeAttribute('hidden');
  });
}

/* ---------- Dates de réception : préparation 1 à 3 j + livraison 6 à 9 j ouvrés ---------- */
function initLivraison(root = document) {
  const t = todayParis();
  const map = {
    '[data-k-d0]': dayLabel(t),
    '[data-k-prep-de]': dayLabel(addWorkdays(t, 1)).replace(/ [^ ]+$/, ''),
    '[data-k-prep-a]': dayLabel(addWorkdays(t, 3)),
    '[data-k-de]': dayLabel(addWorkdays(t, 7)),
    '[data-k-a]': dayLabel(addWorkdays(t, 12)),
  };
  for (const [sel, txt] of Object.entries(map)) setText(root, sel, txt);
  root.querySelectorAll('[data-k-dates]').forEach((el) => el.removeAttribute('hidden'));
}

/* ---------- Onglets (Par type / Par pièce, Au plafond / Au mur, Grille / À l'échelle) ---------- */
function initTabs(root = document) {
  root.querySelectorAll('[data-k-tabs]').forEach((group) => {
    if (group.dataset.kReady) return; group.dataset.kReady = '1';
    const scope = group.closest('[data-k-tabs-scope]') || group.parentElement;
    const tabs = [...group.querySelectorAll('[role="tab"]')];
    const select = (tab) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        const panel = scope.querySelector('#' + t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => select(t));
      t.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        const n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
        n.focus(); select(n);
      });
    });
  });
}

/* ---------- Ajout au panier depuis une section custom (même chemin que product-form d'Horizon) ---------- */
async function kakiAdd(source, variantId, quantity = 1, properties = null) {
  const formData = new FormData();
  formData.set('id', String(variantId));
  formData.set('quantity', String(quantity));
  // propriétés de ligne (ex. _quiz : session du quiz, pour attribuer la commande)
  if (properties) Object.keys(properties).forEach((k) => formData.set(`properties[${k}]`, String(properties[k])));
  const ids = [...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean);
  if (ids.length) formData.append('sections', ids.join(','));
  const deferred = CartLinesUpdateEvent.createPromise();
  source.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: String(variantId), quantity }], promise: deferred.promise }));
  try {
    const res = await fetch(window.Theme?.routes?.cart_add_url || '/cart/add', { method: 'POST', body: formData, headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' } });
    const json = await res.json();
    const cart = await (await fetch((window.Theme?.routes?.cart_url || '/cart') + '.json')).json();
    if (json.status) {
      source.dispatchEvent(new CartErrorEvent({ error: json.message || 'Ajout impossible', code: 'INVALID', detail: { description: json.description } }));
      deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { didError: true, items: cart.items } });
      return { ok: false, message: json.description || json.message };
    }
    deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { didError: false, items: cart.items, sections: json.sections, itemCount: quantity } });
    return { ok: true };
  } catch (e) {
    deferred.reject(e);
    return { ok: false, message: 'Ajout impossible, réessayez.' };
  }
}
window.kakiAdd = kakiAdd;

/* Boutons [data-k-add] : variant dans data-variant, quantité dans data-qty (facultatif) */
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-k-add]');
  if (!btn || btn.disabled) return;
  e.preventDefault();
  const label = btn.querySelector('[data-k-add-label]') || btn;
  const old = label.textContent;
  btn.disabled = true; btn.setAttribute('aria-busy', 'true');
  const r = await kakiAdd(btn, btn.dataset.variant, parseInt(btn.dataset.qty || '1', 10));
  btn.disabled = false; btn.removeAttribute('aria-busy');
  if (r.ok) { label.textContent = 'Ajouté au panier'; setTimeout(() => { label.textContent = old; }, 1800); }
  else { label.textContent = r.message || 'Ajout impossible'; setTimeout(() => { label.textContent = old; }, 2600); }
});

/* ---------- Vedette : choix de la variante (diamètre) ---------- */
function initVedette(root = document) {
  root.querySelectorAll('[data-k-vedette]').forEach((el) => {
    if (el.dataset.kReady) return; el.dataset.kReady = '1';
    const btns = [...el.querySelectorAll('[data-k-variant]')];
    const add = el.querySelector('[data-k-add]');
    const price = el.querySelector('[data-k-price]');
    const size = el.querySelector('[data-k-size]');
    const circles = [...el.querySelectorAll('[data-k-circle]')];
    btns.forEach((b, i) => b.addEventListener('click', () => {
      btns.forEach((x) => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
      circles.forEach((c) => c.classList.toggle('is-on', c.dataset.kCircle === b.dataset.index));
      if (price) price.textContent = b.dataset.price;
      if (size) size.textContent = b.dataset.label;
      if (add) { add.dataset.variant = b.dataset.kVariant; add.disabled = b.dataset.available !== 'true'; }
    }));
  });
}

function initAll(root = document) { initSoir(root); initLivraison(root); initTabs(root); initVedette(root); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
else initAll();
/* Éditeur de thème : réinitialise une section rechargée */
document.addEventListener('shopify:section:load', (e) => initAll(e.target));
